import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { ConfirmButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import BoostIllustration from '../BoostIllustration';

interface Props {
  onRequestClose: () => void;
}

const BoostSuccessModal: React.FC<Props> = ({ onRequestClose }) => {
  const { t } = useTranslation();

  return (
    <MessageModal
      isOpen
      variant="vertical"
      image={<BoostIllustration />}
      onRequestClose={onRequestClose}
      title={t('boostDeviation.successModal.title')}
      message={t('boostDeviation.successModal.message')}
      footerButtons={[
        <ConfirmButton key="confirm" onClick={onRequestClose}>
          {t('common.gotIt')}
        </ConfirmButton>,
      ]}
    />
  );
};
BoostSuccessModal.displayName = 'BoostSuccessModal';

export default BoostSuccessModal;
